import React from 'react';
import propTypes from 'prop-types';
import { Route } from 'react-router-dom'; // ,Redirect
// import { useSelector } from 'react-redux';
import Auth from '../../routes/auth';

function ProtectedRoute({ component, path }) {
  const isLoggedIn = localStorage.getItem('cx_token');
  return isLoggedIn ? <Route component={component} path={path} /> : <Route path="/" component={Auth} />
}

ProtectedRoute.propTypes = {
  component: propTypes.object.isRequired,
  path: propTypes.string.isRequired,
};

export default ProtectedRoute;
